import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

/** Renders the URL prefix for a scope; the `/api` prefix and host are added by the caller. */
const assignmentScopePath = (scope: AssignmentScope): string => {
	switch (scope.type) {
		case 'account': {
			return `accounts/${scope.accountId}/ai-model-assignments`;
		}
		case 'organization': {
			return `organizations/${scope.organizationId}/ai-model-assignments`;
		}
		case 'facility': {
			return `facilities/${scope.facilityId}/ai-model-assignments`;
		}
	}
};

export default assignmentScopePath;
